import { useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'

type SidebarType = {
  id: string
  title: string
  subtitle?: string
}

const useLayout = () => {
  const history = useHistory()
  const observersRef = useRef<IntersectionObserver[]>([])

  const [activeSection, setActiveSection] = useState<string>('detail-dasar')
  const [sidebarMenu, setSidebarMenu] = useState<SidebarType[]>([])
  const [showSuggestion, setShowSuggestion] = useState<boolean>(true)

  const handleGoBack = () => {
    history.push('/dashboard/outbound-so')
  }

  const handleShowSuggestion = (val: boolean) => {
    setShowSuggestion(val)
  }

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId)
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    }
  }

  return {
    activeSection,
    observersRef,
    sidebarMenu,
    setActiveSection,
    setSidebarMenu,
    scrollToSection,
    showSuggestion,
    handleGoBack,
    handleShowSuggestion,
  }
}

export default useLayout
